import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import './theme.css';
import './tablasFijas';
import Routes from './components/Routes'
import '@fortawesome/fontawesome-free/css/all.min.css'; 


ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

